import { createContext, useContext, useEffect, useState } from "react"
import { Outlet } from "react-router-dom";
import setSession from "utils/helpers/setSession";
import axios from "utils/axios";
import { useToast } from "./ToastContext";
import * as apiAuth from "api/apiAuth";
import router from "../routes";

const initState = {
    isLogin: false, 
    token:null,
    user: null
};

   
// Створюємо контекст
const AuthContext = createContext();

 
// Хук контексту 
export const useAuth = () => useContext(AuthContext);

// Компонент контейсту
export const AuthProvider = ({children}) => {
 
    const [ auth, setAuth] = useState(initState);
    const [ isReady, setIsReady ] = useState(false);
    const { showToast } = useToast();
   
    // Авторизація через логін та пароль 
    const LogIn = async (email, password, accessToken) => {
        try {
            const resLogin = accessToken 
                                ? await apiAuth.loginGoogle({accessToken : accessToken})
                                : await apiAuth.loginLocal({email:email, password:password});  

            if (resLogin?.data?.isLogin !== true) {
                return false;
            }
            setAuth(resLogin?.data); 
            setSession(resLogin?.data?.token);
            return true;
        } catch(e){
            console.log(e);
            showToast('API Error', 'danger') 
            return false;
        } 
    } 

    
   
    // Авторизація через токен (відновлення)
    const LogInByJwt = async (jwt) => {
        try {
            setIsReady(false);
            const resLogin = await apiAuth.loginLocal({jwt:jwt});   
            if (!resLogin?.data?.isLogin) LogOut();
            setAuth(resLogin?.data);
            setSession(resLogin?.data?.token);
            setIsReady(true);
        }catch(e){
            console.log(e);
            LogOut();
        }
    }

    const updateAuthUser = (partialUser) => {
        setAuth((prev) => ({
            ...prev,
            user: { ...prev.user, ...partialUser },
        }));
    };

    // Вихід
    const LogOut = async () => {
        try {
            await apiAuth.logout();
            router.navigate('/login');
        } catch(e) {
            console.log(e);
        } finally {
            setSession(null);
            setAuth(initState);
        }
    }

    useEffect(()=>{
        const authToken = localStorage.getItem('authToken');
        LogInByJwt(authToken);
    },[])

 
 
    return isReady
        ? (<AuthContext.Provider  
            value={{auth, LogIn, LogOut, updateAuthUser}}>
            {children}
        </AuthContext.Provider>)
        : (<span className="badge text-bg-primary m-2">Loginning...</span>); 
    
}